module.exports = __webpack_public_path__ + "img/iOS-icon.9a25ce96.svg";